(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('branchOfficeService', branchOfficeService);

    branchOfficeService.$inject = ['$http', 'CONFIG', 'messageService'];


    function branchOfficeService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_CONFIG_GENERAL + '/' + CONFIG.API + '/branchOffices';
        var service = {
            getBranchOffices: getBranchOffices,
            getBranchOffice: getBranchOffice,
            saveBranchOffice: saveBranchOffice,
            updateBranchOffice: updateBranchOffice,
            deleteBranchOffice: deleteBranchOffice,
            getBranchOfficeList: getBranchOfficeList,
            thereNameBranch: thereNameBranch,
            getBranchOfficesByRegion: getBranchOfficesByRegion,
            getBranchOfficesAssociatedAirport: getBranchOfficesAssociatedAirport,
            getBranchOfficesCargo: getBranchOfficesCargo,
            getBranchOfficesByCityCargo: getBranchOfficesByCityCargo
        };

        return service;

        function getBranchOffices(page, size, detailed){
            detailed = (detailed != undefined) ? true  : false;
            return $http.get(urlBase + '?page=' + page + '&size=' + size+"&detailed=" + detailed)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getBranchOffice(branchOfficeId){
            return $http.get(urlBase + "/" + branchOfficeId)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('branchOffices')
                });
        }

        function saveBranchOffice(branchOffice){
            return $http.post(urlBase, branchOffice)
                .then(function(response){
                    messageService.register('branchOffices');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('branchOffices');
                });
        }

        function updateBranchOffice(branchOffice, branchOfficeId){
            return $http.put(urlBase + "/" + branchOfficeId, branchOffice)
                .then(function(response){
                    messageService.registerUpdate('branchOffices');
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdateError('branchOffices')
                });
        }

        function deleteBranchOffice(branchOfficeId){
            return $http.delete(urlBase + "/" + branchOfficeId)
                .then(function(response){
                    messageService.registerDelete('branchOffices');
                    return response;
                })
                .catch(function(){
                    messageService.registerDeleteError('branchOffices');
                });
        }

        function getBranchOfficeList(detailed){
            detailed = (detailed != undefined) ? true  : false;
            return $http.get(urlBase + '/list?detailed=' + detailed)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function thereNameBranch(name){
            return $http.get(urlBase + "/thereNameBranchOffice/" + name, {headers: {'Loading-Overlay': false}})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('')
                });
        }

        function getBranchOfficesByRegion(regionId) {
            return $http.get(urlBase + '/list/' + regionId + '/region')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getBranchOfficesAssociatedAirport(detailed){
            detailed = (detailed != undefined) ? true  : false;
            return $http.get(urlBase + '/list/associatedAirport?detailed=' + detailed)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getBranchOfficesCargo(detailed){
            detailed = (detailed != undefined) ? true  : false;
            return $http.get(urlBase + '/list/onlyCargo?detailed=' + detailed)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getBranchOfficesByCityCargo(cityId) {
            return $http.get(urlBase + '/byCity/' + cityId + '/cargo')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }
    }
})();
